import React from "react";
import { Row, Col } from "react-bootstrap";

import ProductCard from "./ProductCard";

const ProductList = ({
    products = [],
    onProductSelect,
    allowNegative=false
}) => {

    if (!products.length) {
        return (
            <div className="product-list-empty">
                <div className="product-list-empty-text">
                    محصولی یافت نشد
                </div>
            </div>
        );
    }

    return (
        <div className="product-list">
            <Row className="product-list-row">

                {products.map((product, index) => (
                    <Col
                        key={
                            product.id ??
                            product.ID ??
                            product.productId ??
                            index
                        }
                        xs={12}
                        md={6}
                        sm={12}
                        className="product-card-column"
                    >
                        <ProductCard
                            product={product}
                            onClick={onProductSelect}
                            allowNegative ={allowNegative}
                        />
                    </Col>
                ))}

            </Row>
        </div>
    );
};

export default ProductList;
